<template>
  <div class="news-highlight">
    <div class="news-wrapper">
      <div v-for="news in newsList" :key="news.id" class="news-item">
        <p>{{ news.judul }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      newsList: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get("https://mui-kendal.or.id/pengurus/Api/getNews/9");
        this.newsList = response.data.Data;
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
  },
};
</script>

<style scoped>
.news-highlight {
  background-color: #f3f3f3;
  width: 100%;
  overflow: hidden; /* Menyembunyikan bagian yang berada di luar batas */
}

.news-wrapper {
  display: flex;
  animation: scrollNews 10s linear infinite; /* Animasi berjalan */
}

.news-item {
  flex: 0 0 auto;
  margin-right: 50px;
  font-size: 18px;
  white-space: nowrap;
}

@keyframes scrollNews {
  0% {
    transform: translateX(100%); /* Mulai dari sebelah kanan */
  }
  100% {
    transform: translateX(-100%); /* Bergerak ke sebelah kiri */
  }
}
</style>
